import { useCustomTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import { AffectedAssetsTable } from '@ui/drawer/common/AffectedAssetsTable'
import { IssueDrawerLayout } from '@ui/drawer/common/IssueDrawerLayout'
import { IssueDrawerFooter } from '@ui/drawer/common/IssueDrawerFooter'
import { RemediationStepsCard } from '@ui/drawer/common/RemediationStepsCard'
import { useUserLeakedCredIssueDetails } from './useUserLeakedCredIssueDetails'

const UserLeakedCredIssueDetails = () => {
    const theme = useCustomTheme()
    const {
        issue,
        rows,
        columns,
        selectedIds,
        setSelectedIds,
        resolution,
        selectedPayloads,
        selectionDisabled,
    } = useUserLeakedCredIssueDetails()

    const footer = issue.status === 'open' && (
        <IssueDrawerFooter
            resolution={resolution}
            selectedCount={selectedIds.length}
            hasSelectableAssets={rows.length > 0}
            selection={{ assets: selectedPayloads }}
        />
    )

    return (
        <IssueDrawerLayout footer={footer}>
            <Typography
                variant="s-regular"
                noWrap={false}
                color={theme.colors.greys[800]}
                whiteSpaceRule="pre-line"
                testId="user-leaked-cred-issue-short-description"
            >
                {issue.short_description}
            </Typography>
            <RemediationStepsCard issue={issue} />
            <AffectedAssetsTable
                testIdPrefix="user-leaked-cred-assets"
                rows={rows}
                columns={columns}
                selectedIds={selectedIds}
                onSelectionChange={setSelectedIds}
                disabled={selectionDisabled}
                searchable
                searchKeys={['hostname']}
            />
        </IssueDrawerLayout>
    )
}

export default UserLeakedCredIssueDetails
